import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useLexicalNodeSelection } from '@lexical/react/useLexicalNodeSelection';

import { Tooltip } from '../Tooltip';
import { Icon, Text } from '../../atoms';

const WrapText = styled.p`
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  max-width: 260px;
`;

const MentionContainer = styled.span`
  display: inline-flex;
  align-items: center;
  background: var(--gray-8);
  border-radius: 4px;
  column-gap: 2px;
  padding: 0 2px;
  height: 20px;

  ${({ $isSelected }) =>
    $isSelected &&
    `
    box-shadow:  0 0 0 2px var(--white), 0 0 0 3px var(--primary-hover);
  `}
`;

const MetricMentionComponent = forwardRef(({ nodeKey, data, value = null }, ref) => {
  const [isSelected] = useLexicalNodeSelection(nodeKey);

  return (
    <Tooltip content={<WrapText>{data.definition}</WrapText>} position='top'>
      <MentionContainer ref={ref} $isSelected={isSelected}>
        <Icon name='hashtag' color='var(--content-subtitle)' size={20} />
        <Text as='span'>{value}</Text>
      </MentionContainer>
    </Tooltip>
  );
});

MetricMentionComponent.propTypes = {
  nodeKey: PropTypes.string.isRequired,
  data: PropTypes.shape({
    definition: PropTypes.string.isRequired
  }).isRequired,
  value: PropTypes.string
};

export { MetricMentionComponent };
